module.exports = __webpack_public_path__ + "img/pc_menu_logo.8e5cbb67.svg";